import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faFolderOpen, faPersonChalkboard } from '@fortawesome/free-solid-svg-icons'
import { faCalendar as farCalendar, faFolderOpen as farFolderOpen } from '@fortawesome/free-regular-svg-icons'
import { Skeleton } from 'primereact/skeleton';
import img from '../assets/Johnson Courthouse Photo copy.jpg'
import logo from '../assets/Johnson County Transportation Bond logo transparent.png'

export default function Home() {

    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div style={{ position: "relative", width: "100%" }}>
                    <img
                        src={img}
                        className="d-block w-100"
                        style={{ objectFit: "cover" }}
                    />
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        right: "0",
                        transform: "translateY(-50%)",
                        textAlign: "center",
                    }}>
                        <div className="container">
                            <h1 style={{ fontWeight: '600', fontSize: 'clamp(0.8rem, 3vw, 2.5rem)' }} id="bannerText">
                                Johnson County Transportation Bond Program
                            </h1>
                        </div>
                    </div>
                </div>

                <div className="container py-4">

                    <div className="card shadow">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col-sm-3 text-center'>
                                    <img src={logo} height={"300px"} alt="Johnson County Transportation Program" />
                                    <div className='pt-3'>

                                    </div>
                                </div>
                                <div className="col-sm-9">

                                    {/*<h1 className='mb-3'>Johnson County Bond Program</h1>*/}
                                    <h5>
                                        Voters approved the county's first transportation bond program on November 5, 2024!
                                    </h5>
                                    <p>
                                        With the significant population growth and many residents relying on the roadway system for their daily commute, there was an increased demand on the infrastructure.  This $60 million bond program aims to enhance safety and mobility for residents.

                                    </p>
                                    <p>
                                        The bond program will also support ongoing efforts by the Texas Department of Transportation (TxDOT) and the North Central Texas Council of Governments (NCTCOG). It will focus on project planning and engineering, with the goal of partnering with TxDOT and NCTCOG to secure additional state and federal funds for construction.
                                    </p>
                                    <p>
                                        Please visit the  <Link to='/projects' style={{ color: "#466580" }}>Projects</Link> tab  for more information.
                                    </p>
                                    <p>
                                        <a className='pe-5' href="https://www.x.com/@JohnsonCoBond" target='_blank' style={{ textDecoration: "none", color: "#466580", fontSize:'large', fontWeight:'500' }}>
                                            <span className='pb-2'><i className="fa-brands fa-square-x-twitter"></i> @JohnsonCoBond</span>
                                        </a>
                                        <a className='pe-5' href="https://www.instagram.com/JohnsonCountyBond" target='_blank' style={{ textDecoration: "none", color: "#466580", fontSize:'large', fontWeight:'500' }}>
                                            <span className='pb-2'><i className="fa-brands fa-instagram"></i> @JohnsonCountyBond</span>
                                        </a>
                                        <a className='' href="https://www.facebook.com/people/Johnson-County-Transportation-Bond/61566498354803/" target='_blank' style={{ textDecoration: "none", color: "#466580", fontSize:'large', fontWeight:'500' }}>
                                            <span><i className="fa-brands fa-square-facebook"></i> Johnson County Transportation Bond</span>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*}
                    <div className='card shadow'>
                        <div className='card-body'>
                            <div className='row p-4 text-center'>
                                //-->
                            <div className='col-lg-4'>
                                <Link to='/events' style={{ textDecoration: "none", color: "#466580" }}>
                                    {calendaricn}
                                    <h5 className='my-2'>Events</h5>
                                </Link>
                            </div>
                            <--//
                                <div className='col-lg-4'>
                                    <Link to='/projects' style={{ textDecoration: "none", color: "#466580" }}>
                                        {foldericn}
                                        <h5 className='my-2'>Projects</h5>
                                    </Link>
                                </div>
                                //-->
                            <div className='col-lg-4'>
                                <Link to='/presentations' style={{ textDecoration: "none", color: "#466580" }}>
                                    {charticn}
                                    <h5 className='my-2'>Reports</h5>
                                </Link>
                            </div>
                            <--//
                            </div>
                        </div>
                    </div>
                    */}

                </div>

            </main >
        </div >
    )
}